import { classifications } from './types/config';

export const config = {
  imageBaseUrl: import.meta.env.VITE_IMAGE_BASE_URL,
  apiUrl: import.meta.env.VITE_API_URL || 'http://0.0.0.0:8000',
  appUrl: import.meta.env.VITE_APP_URL || 'http://localhost:5200',
  classifications,
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
  frigade: {
    apiKey: import.meta.env.VITE_FRIGADE_API_KEY,
    flows: {
      demoAssignmentHint: 'flow_n0824QbD',
      homeAnnouncement: 'flow_zSde0ZdY',
      rubricCriteria: 'flow_CoxLTX8s',
      blockHint: 'flow_Y5GjPI14',
      noteHint: 'flow_W3VxEG5B',
      highlightHint: 'flow_4cTw5Gki',
      aiSuggestionHint: 'flow_CpqFXk43',
      rubricSuggestionHint: 'flow_IpLxhWX1',
      feedbackHint: "flow_NWyKLnvC",
      manageAssessmentsHint: "flow_iFDR6agL",
      gradeHint: "flow_yDfhEhRP",
      reportsViewHint: "flow_T0P0xmB2",
      rubricViewHint: 'flow_13b8LKHV',
      rubricViewAnnouncement: 'flow_iexnc0Hr',
      readerAnnouncement: 'flow_3apFGp2x',
      generateReportHint: 'flow_KrcYHr9P',
      gettingStarted: 'flow_QKHpqd3Y',
      shareFeedbackHint: "flow_QbGIBle2",
      onboardingSurvey: "flow_HLM2VmNn",
    }
  },
  isProduction: import.meta.env.VITE_ENVIRONMENT?.toLowerCase() === 'production',
  // Sentry configuration
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN || '',
    sendDefaultPii: import.meta.env.VITE_SENTRY_SEND_DEFAULT_PII === 'true' || true,
  },
  // Mixpanel configuration
  mixpanel: {
    token: import.meta.env.VITE_MIXPANEL_TOKEN || '',
    debug: false,
    persistence: import.meta.env.VITE_MIXPANEL_PERSISTENCE || 'localStorage',
    recordSessionsPercent: import.meta.env.VITE_MIXPANEL_RECORD_SESSIONS_PERCENT || 100,
  },
  /**
   * Feature flags configuration
   * Set VITE_FEATURES environment variable as a JSON string with key-value pairs
   * Example: VITE_FEATURES='{"feedbackExport":true,"newFeature":false}'
   * Use the useFeature() hook to check if a feature is enabled in components
   */
  features: (() => {
    try {
      const featuresJson = import.meta.env.VITE_FEATURES;
      return featuresJson ? JSON.parse(featuresJson) : {};
    } catch (error) {
      console.error('Failed to parse VITE_FEATURES environment variable:', error);
      return {};
    }
  })(),
} as const;
